import { IPOIState, POI_STATE } from './poi/poi.model';
import { IItinState, ITIN_STATE } from './itinerari/itinerari.model';
import { IUserState, USER_STATE } from './users/users.model';
import { IThemesState, THEMES_STATE } from './themes/themes.model';
import { IGeoPosState, GEOPOS_STATE } from './geographicalpos/geographicalpos.model';
import { ILoggedState, LOGGED_STATE } from './logged/logged.model';

export interface IAppState {
    poi: IPOIState;
    itin: IItinState;
    user: IUserState;
    logged: ILoggedState;
    theme: IThemesState;
    geopos: IGeoPosState;
}

export const INITIAL_STATE = {
    poi : POI_STATE,
    itin : ITIN_STATE,
    user : USER_STATE,
    logged: LOGGED_STATE,
    theme : THEMES_STATE,
    geopos : GEOPOS_STATE,
};
